import { combineReducers } from 'redux';
import Organization from './Organization';
import Position from './Position';

export default combineReducers({
  Organization,
  Position,
});
